import * as React from 'react';
import * as ReactDOM from 'react-dom';
import forEach from '../utilities/forEach';
import getPropsFromAttributes from '../utilities/getPropsFromAttributes';
import Chatbotselector from './Components/ChatBotSelector'
import IChatbotProps from './Interface/IChatbotProps';

const SELECTOR = '[data-react-component="GTAA-chatbot"]';

function main() {
	const elements = document.querySelectorAll(SELECTOR);

	forEach(elements, (element) => {
		const props = getPropsFromAttributes(element) as IChatbotProps;
		ReactDOM.render(<Chatbotselector chatbotsettings={props} />, element);
	});
}

main();
